enum OrderSearchTabType {
    Orders = 'orders',
    Invoices = 'invoices',
}

export default OrderSearchTabType;
